import React from 'react';
import Hero from '../sections/Hero';
import HeroCounter from '../sections/HeroCounter';
import SlidingSection from '../sections/SlidingSection';
import HowItworks from '../sections/HowItWorks';
import BentoGrids from '../sections/BentoGrids';

const Home = () => {
  return (
    <div>
      <Hero />
      <HeroCounter />
      <SlidingSection />
      <HowItworks />
      <BentoGrids />
    </div>
  );
};

export default Home; 